import * as fa from "@fortawesome/free-solid-svg-icons";
import React, { type ReactNode } from "react";
import { IconButton } from "../form/Button";
import { SearchInput } from "./SearchInput";

interface SearchAndReloadProps<T> {
  data: T[];
  filterProperties: (keyof T)[];
  resultsBuilder: (results: T[]) => ReactNode;
  onReload?: () => void;
  overrideSearch?: string;
  overrideOnSearchChange?: (newSearch: string) => void;
}

export function SearchReload<T>(props: SearchAndReloadProps<T>): ReactNode {
  const [_search, _setSearch] = React.useState("");
  const search = props.overrideSearch ?? _search;
  const setSearch = props.overrideOnSearchChange ?? _setSearch;
  const filteredData = React.useMemo(() => {
    if (search === "") {
      return props.data;
    }
    return props.data.filter((item) => {
      const values =
        props.filterProperties?.map((key) => {
          return item[key];
        }) ?? [];
      return applyFilter(values, search);
    });
  }, [props.data, props.filterProperties, search]);

  return (
    <div>
      <div className={"flex items-end justify-between mb-4"}>
        <div className={"flex-1"}>
          <SearchInput value={search} focus onChange={setSearch} />
        </div>
        {props.onReload ? (
          <IconButton icon={fa.faRefresh} onClick={props.onReload} type={"secondary"} size={"sm"} />
        ) : null}
      </div>
      <div>{props.resultsBuilder(filteredData)}</div>
    </div>
  );
}

function applyFilter(values: unknown[], query: string): boolean {
  const queries = query.split(" ");
  return queries.every((q) =>
    values.some((v) => JSON.stringify(v).toLowerCase().includes(q.toLowerCase())),
  );
}
